function applyScript() {
  // TO MOVE THE HELP TEXT ABOVE(MAKE AS HEADER)
  setTimeout(() => {
    var helpText = document.querySelector('.bold_option_uploadfile .bold_help_text');

    if (helpText) {
        var parentElement = document.querySelector('.bold_option_uploadfile').parentNode;

        parentElement.parentNode.insertBefore(helpText, parentElement);
    } else {
        console.error("Help text element not found.");
    }

  // TO MOVE THE HELP TEXT ABOVE(MAKE AS HEADER)
  }, 500);
  

  // START OF SCRIPT
    // Create a new label element template
    const labelTemplate = document.createElement('label');
    labelTemplate.textContent = 'Add Photo';

    // Create a new label text element template
    const labelTextTemplate = document.createElement('label');
    labelTextTemplate.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M11 2v9H2v2h9v9h2v-9h9v-2h-9V2z"/>
        </svg>
    `;

    // Get all input elements with type="file"
    const inputFileElements = document.querySelectorAll('input[type="file"]');

    // Loop through each input element and apply the label and image tag
    inputFileElements.forEach((inputFile, index) => {
        
        // Create a unique ID for each input element
        const uniqueId = `file-upload-${index}`;

        // Clone the label elements and set their "for" attributes to the unique ID
        const labelElement = labelTemplate.cloneNode(true);


        const text = inputFile.closest('.bold_option_uploadfile').querySelector('.bold_option_title').textContent
        labelElement.textContent = text

        labelElement.setAttribute('for', uniqueId);
        labelElement.setAttribute('class', `firstButton-${index}`);

        const labelTextElement = labelTextTemplate.cloneNode(true);
        labelTextElement.setAttribute('for', uniqueId);
        labelTextElement.setAttribute('id', `file-input-label-${index}`);
        labelTextElement.setAttribute('class', `custom-file-upload-text-${index}`);

        // Add the unique ID to the input element
        inputFile.setAttribute('id', uniqueId);

        // Prepend the label element before the input element
        inputFile.parentNode.insertBefore(labelElement, inputFile);

        // Append the label element text to the parent
        inputFile.parentNode.appendChild(labelTextElement);

        // we create image tag template
        const imgTemplate = document.createElement('img');
        imgTemplate.setAttribute('id', `previewImage-${index}`);
        imgTemplate.setAttribute('alt', 'Preview');
        imgTemplate.setAttribute('src', '');
        imgTemplate.setAttribute('style', 'max-width: 200px; max-height: 200px;');
        const imgElement = imgTemplate.cloneNode(true);
        inputFile.parentNode.appendChild(imgElement);

        // we create a clear/reset button
        const clearButton = document.createElement('button');
        clearButton.textContent = 'Clear';
        clearButton.type = 'button'; // Ensure button type is 'button' to prevent form submission since it will add the actual product to the cart (lets prevent that)
        clearButton.style.display = 'none'; 
        clearButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default form submission behavior
            inputFile.value = ''; 
            labelTextElement.style.display = 'block'; 
            imgElement.src = ''; // lets clear the preview image
            labelElement.textContent = text; 
            clearButton.style.display = 'none';
        });
        inputFile.parentNode.appendChild(clearButton);

        function generateThumbnail(file, callback) {
            const reader = new FileReader();
            reader.onload = function(e) {
                const img = new Image();
                img.onload = function() {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const maxThumbnailSize = 100;
                    let width = img.width;
                    let height = img.height;
                    if (width > height) {
                        if (width > maxThumbnailSize) {
                            height *= maxThumbnailSize / width;
                            width = maxThumbnailSize;
                        }
                    } else {
                        if (height > maxThumbnailSize) {
                            width *= maxThumbnailSize / height;
                            height = maxThumbnailSize;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
                    canvas.toBlob(function(blob) {
                        callback(blob);
                    }, file.type);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }

        function previewSelectedImage(event) {
            const file = event.target.files[0];
            const previewImage = event.target.parentNode.querySelector('img');
            const labelText = event.target.parentNode.querySelector(`.custom-file-upload-text-${index}`);
            const plusIcon = event.target.parentNode.querySelector(`.svg-plus-icon-${index}`);
            const clearButton = event.target.parentNode.querySelector('button');

            
            if (!file) {
                return;
            }

            if (!file.type.startsWith('image/')) {
                alert('Please select an image file (JPEG, PNG, etc.)');
                event.target.value = '';
                return; 
            }

            // then we shall continue with image preview if the file is an image
            generateThumbnail(file, function(thumbnailBlob) {
                const reader = new FileReader();
                reader.onload = function(e) {
                    previewImage.src = e.target.result;
                    labelText.style.display = 'none';
                    if (plusIcon) {
                        plusIcon.remove();
                    }
                    labelElement.textContent = '';
                    clearButton.style.display = 'block';
                    previewImage.classList.add('preview-image'); // Add the class for animation
                };
                reader.readAsDataURL(thumbnailBlob);
            });
        }



        // Add event listener to input file element for image preview
        inputFile.addEventListener('change', previewSelectedImage);
    });
}

function observeDOM() {
    var observer = new MutationObserver(function(mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
                console.log("bold after script");
                applyScript();
                observer.disconnect();
                break;
            }
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener('DOMContentLoaded', function() {
    observeDOM();
});